import { createContext } from 'react'

const StateContext = createContext(null)
const DispatchContext = createContext(null)

export { StateContext, DispatchContext };